module.exports = __webpack_public_path__ + "static/img/empleadorhome-768x1024.ade205a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/home/empleadorhome-768x1024.jpg
// module id = xvyp
// module chunks = 47